import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardContent = styled(Typography)({
  fontWeight: 300,
  fontSize: "16px",
});
